// Shared tab header. Lived under routes/audiences/AudienceUpsell until
// ATAD-132 gave the admin Orders page a second consumer; importing it
// across feature folders would have been the worse edge.
export default function Tab({ label, selected, onClick }) {
  return (
    <div
      className="hover:text-primary text-lg px-3 cursor-pointer"
      onClick={onClick}
    >
      <div
        className={`pb-2 ${
          selected ? 'font-bold text-primary border-b-4 border-primary' : ''
        }`}
      >
        {label}
      </div>
    </div>
  );
}
